import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useApiConnectivityStore } from 'web/stores/apiConnectivitityStore';

const ApiConnectivityBanner = () => {
    const hasConnectionIssue = useApiConnectivityStore(state => state.hasConnectionIssue);

    if (!hasConnectionIssue) return null;

    return (
        <div className="w-full bg-red-600 text-white py-2 px-4 text-center font-semibold absolute top-0 left-0 z-50">
            <FontAwesomeIcon icon="wifi" className="mr-2" />
            Server connection issue detected. Some features may not work correctly.
        </div>
    );
};

export default ApiConnectivityBanner;
